// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonInfo_wrapper__ytX+Y","list__container":"PersonInfo_list__container__7DON3","list__item":"PersonInfo_list__item__m7TWE","item__title":"PersonInfo_item__title__Y3fpV"};